/**
 * @generated SignedSource<<1d02971073a1638882d7c344d3499f84>>
 * @relayHash c2520b5a14cebe599d200b80b33551cc
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/555.0.0-2026-04-14T15:58:38.329Z/updateSellerApplicationLeadMutation

import { ConcreteRequest } from 'relay-runtime';
export type UpdateSellerApplicationLeadInput = {
  associations?: string | null;
  averageItemPrice?: string | null;
  businessItems?: ReadonlyArray<SampleItem | null> | null;
  businessType?: string | null;
  clientMutationId?: string | null;
  consignmentBasis?: boolean | null;
  consignorItems?: ReadonlyArray<ConsignorItems | null> | null;
  currencyISOCode?: string | null;
  estimatedInventorySize?: string | null;
  estimatedMonthlyUploads?: string | null;
  fairs?: string | null;
  galleryRepresentation?: boolean | null;
  hoursManagePerWeek?: string | null;
  isSellerOnOtherMarketPlace?: boolean | null;
  locations?: string | null;
  locationsWithinSelectedCountry?: boolean | null;
  numSoldLastYear?: string | null;
  otherMarketPlaceDetails?: string | null;
  ownInventory?: boolean | null;
  preferredLanguage?: string | null;
  primaryBusinessFocus?: string | null;
  recordId?: string | null;
  specialty?: string | null;
  step?: string | null;
  whereRepresented?: string | null;
};
export type SampleItem = {
  category?: string | null;
  condition?: string | null;
  creatorArtistDesigner?: string | null;
  customizable?: boolean | null;
  description?: string | null;
  imageFiles?: ReadonlyArray<any | null> | null;
  materials?: string | null;
  medium?: string | null;
  metals?: ReadonlyArray<string | null> | null;
  moreSizesAndEditions?: boolean | null;
  period?: string | null;
  price?: string | null;
  restorationAndModifications?: boolean | null;
  stoneCut?: string | null;
  stones?: ReadonlyArray<string | null> | null;
  subCategory?: string | null;
  title?: string | null;
};
export type ConsignorItems = {
  category?: string | null;
  condition?: string | null;
  creator?: string | null;
  howItemWasAcquired?: string | null;
  imageFile?: any | null;
  price?: string | null;
  subCategory?: string | null;
};
export type updateSellerApplicationLeadMutation$variables = {
  input: UpdateSellerApplicationLeadInput;
};
export type updateSellerApplicationLeadMutation$data = {
  readonly UpdateSellerApplicationLead: {
    readonly leadId: string | null;
  } | null;
};
export type updateSellerApplicationLeadMutation = {
  response: updateSellerApplicationLeadMutation$data;
  variables: updateSellerApplicationLeadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateSellerApplicationLeadPayload",
    "kind": "LinkedField",
    "name": "UpdateSellerApplicationLead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "leadId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateSellerApplicationLeadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateSellerApplicationLeadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-misc/555.0.0-2026-04-14T15:58:38.329Z/updateSellerApplicationLeadMutation",
    "metadata": {},
    "name": "updateSellerApplicationLeadMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d02f43358b5083d6e5103abea664845d";

export default node;
